import { getGlobalPromoTag, getPromoTagMarkup } from './utils.js';

window.BOLD = window.BOLD || {};
BOLD.BMS = BOLD.BMS || {};
/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery._jscookie = function (b, j, m) {
  if (typeof j != 'undefined') {
    m = m || {};
    if (j === null) {
      j = '';
      m.expires = -1;
    }
    let e = '';
    if (m.expires && (typeof m.expires == 'number' || m.expires.toUTCString)) {
      let f;
      if (typeof m.expires == 'number') {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = '; expires=' + f.toUTCString();
    }
    const l = m.path ? '; path=' + m.path : '';
    const g = m.domain ? '; domain=' + m.domain : '';
    const a = m.secure ? '; secure' : '';
    document.cookie = [b, '=', encodeURIComponent(j), e, l, g, a].join('');
  } else {
    let d = null;
    if (document.cookie && document.cookie != '') {
      const k = document.cookie.split(';');
      for (let h = 0; h < k.length; h++) {
        const c = String.prototype.trim.call(k[h] == null ? '' : k[h]);
        if (c.substring(0, b.length + 1) == b + '=') {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};

BOLD.BMS.RecentProducts = (function ($) {
  let compiledTemplate;
  const config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    onCompconste: null
  };

  let productHandleQueue = [];
  let products = [];
  let shown = 0;

  const cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      $._jscookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function () {
      let recentlyViewed = [];
      const cookieValue = $._jscookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(/[ ]+/);
      }
      return recentlyViewed;
    },
    destroy: function () {
      $._jscookie(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      let recentlyViewed = this.read();
      const position = $.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  const fetchAndRender = function () {
    const currentPageProductHandle = window.location.pathname.match(
      /\/products\/([a-z0-9\-]+)/
    )[1];
    if (
      productHandleQueue[0] === currentPageProductHandle ||
      (products.length && productHandleQueue[0] === products[0].handle)
    ) {
      productHandleQueue.shift();
      return fetchAndRender();
    }
    if (productHandleQueue.length && shown < config.howManyToShow) {
      return fetch('/products/' + productHandleQueue[0] + '.js')
        .then(response => {
          if (!response.ok) {
            console.error('Network response was not ok');
            return;
          }
          return response.json();
        })
        .then(product => {
          // Add waitlist promo tag if the product has the 'waitlist' tag
          if (product.tags.includes('waitlist')) {
            const waitlistTag = getGlobalPromoTag('waitlist');
            if (waitlistTag) {
              product.waitlistPromoTag = getPromoTagMarkup(waitlistTag);
            }
          }
          products.push(product);
        })
        .then(() => {
          productHandleQueue.shift();
          shown++;
          return fetchAndRender();
        })
        .catch(error => {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          console.error('Fetch Error: ' + error);
          return fetchAndRender();
        });
    } else {
      return render();
    }
  };

  const render = () => {
    if (products.length) {
      const recentProductsHtml = compiledTemplate({ products: products });
      $('#product-recent').html(recentProductsHtml);
    } else {
      $('#product-recent').parent().remove();
    }
    recordRecentlyViewed();
  };

  const recordRecentlyViewed = () => {
    // Read cookie.
    let recentlyViewed = cookie.read();

    // If we are on a product page.
    if (window.location.pathname.indexOf('/products/') !== -1) {
      // What is the product handle on this page.
      const productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];
      // In what position is that product in memory.
      const position = $.inArray(productHandle, recentlyViewed);
      // If not in memory.
      if (position === -1) {
        // Add product at the start of the list.
        recentlyViewed.unshift(productHandle);
        // Only keep what we need.
        recentlyViewed = recentlyViewed.splice(
          0,
          config.howManyToStoreInMemory
        );
      } else {
        // Remove the product and place it at start of list.
        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }

      // Update cookie.
      cookie.write(recentlyViewed);
    }
  };

  function init(template) {
    compiledTemplate = Handlebars.compile(template);
    productHandleQueue = cookie.read();
    fetchAndRender();
  }

  return {
    init: init,
    recordRecentlyViewed: recordRecentlyViewed
  };
})(BOLD.$ || $);
